import { useCallback, useEffect, useState } from "react";
import { api } from "../../utils/api";
import { useAuthorization } from "../../authorization/useAuthorization";
import { AuthorizationErrorMessage } from "../../authorization/AuthorizationErrorMessage";
import { ErrorMessage } from "../../authorization/ErrorMessage";
import { useParams } from "react-router-dom";
import type z from "zod";
import { schemas } from "../../api/generated";

type File = z.infer<typeof schemas.File>;

const UserFiles = () => {
  const { userId } = useParams();
  const [files, setFiles] = useState<File[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const auth = useAuthorization({
    userTypes: [/*"Admin",*/ "User"],
    resourceUserId: userId,
  });

  const fetchFiles = useCallback(async (token: string, userId: string) => {
    try {
      const data = await api.getUserFiles(token, userId);
      const filesData = data.files || []; // Ensure filesData is not null or undefined
      setFiles(filesData);
      setErrorMessage(""); // Clear any previous error message
    } catch (error) {
      console.log("Error retrieving files:", error);
      setFiles([]); // Reset files to an empty array on error
      setErrorMessage("Error retrieving files");
    }
  }, []);

  useEffect(() => {
    const resourceUserId = userId || (auth.authorized && auth.userId); // Use the provided userId or fallback to auth's userId
    if (auth.authorized && resourceUserId) {
      setTimeout(() => {
        fetchFiles(auth.token, resourceUserId);
      }, 0);
    }
  }, [auth, userId, fetchFiles]);

  if (!auth.authorized) {
    return <AuthorizationErrorMessage {...auth} />;
  } else if (errorMessage) {
    return <ErrorMessage message={errorMessage} />;
  }

  return [
    <div className="my-md-3 my-1">
      <h2>User Files</h2>
      {files.length === 0 ? (
        <p>No files available</p>
      ) : (
        <ul>
          {files.map((file, index) => (
            <li key={index}>
              <a href={`/file-download/${file.fileName}`}>{file.fileName}</a>
            </li>
          ))}
        </ul>
      )}
    </div>,
  ];
};

export default UserFiles;
